import React from 'react';
import CadastroPjBillingAddressComponent from './cadastro-pj-billing-address-component';
import CadastroPjCompanyComponent from './cadastro-pj-company-component';
import {
  BILLING_ADDRESS,
  BUYER_AND_COMPANY,
  DOCUMENT_CHECK,
  FINISH
} from './cadastro-pj-component';
import CadastroPjDocumentComponent from './cadastro-pj-document-component';
import CadastroPjFinishComponent from './cadastro-pj-finish-component';
import {
  clearBuyerAlreadyRegistered,
  createCustomer,
  goBackToFirstForm,
  goToPreviousForm,
  validateSubmit
} from './cadastro-services';

const CadastroPjForms = ({ state, setCadastroPjDocumentState }) => {
  const {
    formState: currentStep,
    formDataState,
    customerQualifyerData,
    buyerAlreadyRegistered
  } = state;
  switch (currentStep) {
    default:
    case DOCUMENT_CHECK:
      return (
        <CadastroPjDocumentComponent
          setCadastroPjDocumentState={setCadastroPjDocumentState}
          submitHandler={validateSubmit}
          formDataState={formDataState}
          currentStep={currentStep}
        />
      );
    case BUYER_AND_COMPANY:
      return (
        <CadastroPjCompanyComponent
          submitHandler={validateSubmit}
          formDataState={formDataState}
          setCadastroPjDocumentState={setCadastroPjDocumentState}
          currentStep={currentStep}
          hasCustomerQualifyer={customerQualifyerData.success}
          goBackStep={goToPreviousForm}
          buyerAlreadyRegistered={buyerAlreadyRegistered}
          clearBuyerAlreadyRegistered={clearBuyerAlreadyRegistered}
        />
      );
    case BILLING_ADDRESS:
      return (
        <CadastroPjBillingAddressComponent
          submitHandler={createCustomer}
          formDataState={formDataState}
          customerQualifyerData={customerQualifyerData}
          setCadastroPjDocumentState={setCadastroPjDocumentState}
          currentStep={currentStep}
          goBackStep={goToPreviousForm}
          goBackToFirstStep={goBackToFirstForm}
        />
      );
    case FINISH:
      return <CadastroPjFinishComponent />;
  }
};

export default CadastroPjForms;
